"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const opaque_1 = require("./framework/opaque");
exports.TestStatus = opaque_1.opaqueOfString();
const TestStatusesKeys = {
    in_progress: 'in_progress',
    done: 'done',
    not_started: 'not_started'
};
exports.TestStatuses = Object.keys(TestStatusesKeys).reduce((acc, k) => (Object.assign(Object.assign({}, acc), { [k]: exports.TestStatus.wrap(k) })), {});
exports.getTestStatus = (testSession) => testSession.isDone
    ? exports.TestStatuses.done
    : (testSession.answersIds || []).length > 0
        ? exports.TestStatuses.in_progress
        : exports.TestStatuses.not_started;
//# sourceMappingURL=testSessions.js.map


//////////////////
// WEBPACK FOOTER
// ../models/dist/testSessions.js
// module id = 382
// module chunks = 12